<template>
  <div class="row justify-content-center">
    <div :class="[{'col-lg-5 col-md-7' : timeKeepAccountDetails.time_entry_log_via == 'TEB' || timeKeepAccountDetails.time_entry_log_via == null || timeKeepAccountDetails.time_entry_log_via == undefined}, {'col-lg-12 col-md-12' : timeKeepAccountDetails.time_entry_log_via == 'TES'}]">
      <div v-if="errors.length" id="errorNotification">
        <base-alert type="danger">
          <b>You have the following error(s):</b>
          <li  class="alert-inner--text" v-for="error in errors" :key="error">{{ error }}</li>
      </base-alert>
      </div>
      <div v-else-if="successMessage != null">
        <base-alert type="success">
          <span class="alert-inner--text"> {{ successMessage }}</span> <br>
        </base-alert>
      </div>
      <div class="card bg-secondary shadow border-0">
        <div class="card-body">
          <div class="row">
            <div :class="[{'col-md-5 col-lg-5' : timeKeepAccountDetails.time_entry_log_via == 'TES'}, {'col-lg-12 col-md-12' : timeKeepAccountDetails.time_entry_log_via == 'TEB' || timeKeepAccountDetails.time_entry_log_via == null || timeKeepAccountDetails.time_entry_log_via == undefined}]">
              <div class="card  bg-secondary border-0">
                <div class="card-body">
                  <h1>Time Entry</h1> <br>
                  <form role="form">
                    <div class="form-group input-group-alternative mb-3 input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-building"></i></span>
                      </div>
                      <input aria-describedby="addon-right addon-left" v-model="accountName" :disabled="validAccount" placeholder="Account Name" class="form-control">
                      <div class="input-group-prepend" v-if="validAccount">
                        <button class="btn btn-outline-secondary btn-sm" @click="changeAccount(true)" type="button">change</button>
                      </div>
                    </div>
                    <div class="form-group input-group-alternative mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa-solid fa-location-crosshairs"></i></span>
                        <a-select
                            :disabled="!validAccount"
                            show-search
                            size="large"
                            style="width: 100%"
                            placeholder="Site"
                            optionFilterProp="children"
                            v-model="siteId">
                            <a-select-option v-for="site in siteOptions" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                        </a-select>
                      </div>
                    </div>

                    <div class="form-group input-group-alternative mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa-solid fa-clock"></i></span>
                        <a-select
                            :disabled="!validAccount"
                            show-search
                            size="large"
                            style="width: 100%"
                            placeholder="Entry Type"
                            optionFilterProp="children"
                            v-model="entryTypeId">
                            <a-select-option v-for="entry_type in timeEntryOptions" :key="entry_type.id" :value="entry_type.id">{{entry_type.name}}</a-select-option>
                        </a-select>
                      </div>
                    </div>
                    <div v-if="timeKeepAccountDetails.time_entry_log_via == 'TEB'">
                      <base-input class="input-group-alternative mb-4" addon-left-icon="fa fa-hand-pointer">
                        <select name="readerSelect" id="enrollReaderSelect" class="form-control" v-model="selectedFingerprintReader">
                            <option value="">Select Fingerprint Reader</option>
                            <option v-for="option in FingerprintReaderOptions" :value="option">{{ option }}</option>
                        </select>
                      </base-input>
                      <div class="form-row justify-content-center mb-1">
                        <div class="col mb-3 mb-md-0 text-center" v-for="index in verifyFingerPrint">
                            <i class="fa fa-fingerprint text-green  fa-2xl"></i>
                        </div>
                        <div class="col mb-3 mb-md-0 text-center" v-for="finger_not_scan in (1 - verifyFingerPrint.length)">
                            <i class="fa fa-fingerprint fa-2xl"></i>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <base-input class="input-group-alternative mb-3" placeholder="Username/Email"
                        addon-left-icon="ni ni-email-83" v-model="email" :disabled="!validAccount">
                      </base-input>

                      <base-input class="input-group-alternative mb-3" @keyup.enter="addTimeEntryViaSignIn" placeholder="Password"
                        type="password" addon-left-icon="ni ni-lock-circle-open" v-model="password" :disabled="!validAccount">
                      </base-input>
                    </div>
                    <div class="text-center">
                      <base-button v-if="validAccount && timeKeepAccountDetails.time_entry_log_via == 'TEB'" type="warning" class="my-4" @click.prevent="addTimeEntryViaBiometric" style="width: 50%;"
                          :disabled="loadingTimeEntry">
                          <a-spin v-if="loadingTimeEntry" :spinning="loadingTimeEntry" />
                          <div v-else>Time Entry</div>
                      </base-button>
                      <base-button v-if="validAccount && timeKeepAccountDetails.time_entry_log_via == 'TES'" type="warning" class="my-4" @click.prevent="addTimeEntryViaSignIn" style="width: 50%;"
                          :disabled="loadingTimeEntry">
                          <a-spin v-if="loadingTimeEntry" :spinning="loadingTimeEntry" />
                          <div v-else>Time Entry</div>
                      </base-button>
                      <base-button v-if="!validAccount" type="primary" class="my-4" @click.prevent="checkIfValidAccount(true)" style="width: 50%;"
                          :disabled="loading">
                          <a-spin v-if="loading" :spinning="loading" />
                          <div v-else>Validate</div>
                      </base-button>
                      <br>
                      <small>Already have an account? </small>
                      <a @click="Login" class="text-dark"><small class="signUpText">Login</small></a><br>
                      <small>Don't have an account? </small>
                      <a @click="signUp" class="text-dark"><small class="signUpText">Sign up</small></a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-7 col-lg-7" v-if="timeKeepAccountDetails.time_entry_log_via == 'TES'">
              <div class="card" >
                <div class="card-body">
                  <a-spin v-if="isCameraOpen && isLoading" :spinning="isLoading" />
                  <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                    <video v-show="!isPhotoTaken" ref="camera" width="100%" height="100%" autoplay></video>
                    <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" width="100%" height="100%"></canvas>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import axios from "axios";
import moment from 'moment'

import Fingerprint2 from 'fingerprintjs2'
import ValidateField from '../components/validateFormUtils'
import { uploadToS3 } from '../utilities';

// import '../directives/es6-shim.js'
import '../directives/websdk.client.bundle.min.js'
import Fingerprint from '../directives/fingerprint.sdk.min.js'

var options = {}
var browserId = ""

// import axios from "axios";
var navigate;
var component_x;

let currentFormat = Fingerprint.SampleFormat.Intermediate;

let FingerprintSdkTest = (function () {
  function FingerprintSdkTest() {
      this.operationToRestart = null;
      this.acquisitionStarted = false;
      // instantiating the fingerprint sdk here
      this.sdk = new Fingerprint.WebApi;
      this.sdk.onDeviceConnected = function (e) {
        // Detects if the device is connected for which acquisition started
        component_x.showMessage("Scan Appropriate Finger on the Reader", "success");
      };
      this.sdk.onDeviceDisconnected = function (e) {
        // Detects if device gets disconnected - provides deviceUid of disconnected device
        component_x.showMessage("Device is Disconnected. Please Connect Back");
      };
      this.sdk.onCommunicationFailed = function (e) {
        // Detects if there is a failure in communicating with U.R.U web SDK
        // component_x.showMessage("Communication Failed. Please Reconnect Device")
      };
      this.sdk.onSamplesAcquired = function (s) {
        // Sample acquired event triggers this function
        component_x.storeSample(s);
      };
      this.sdk.onQualityReported = function (e) {
        // Quality of sample acquired - Function triggered on every sample acquired
        // document.getElementById("qualityInputBox").value = Fingerprint.QualityCode[(e.quality)];
      }
    }

    // this is were finger print capture takes place
    FingerprintSdkTest.prototype.startCapture = function () {
        if (this.acquisitionStarted) // Monitoring if already started capturing
            return;
        let _instance = this;
        component_x.showMessage("");
        this.operationToRestart = this.startCapture;
        this.sdk.startAcquisition(currentFormat, "").then(function () {
            component_x.acquisitionStarted = true;

            //Disabling start once started
            //disableEnableStartStop();

        }, function (error) {
            component_x.showMessage(error.message);
        });
    };
  
    FingerprintSdkTest.prototype.stopCapture = function () {
        if (!this.acquisitionStarted) //Monitor if already stopped capturing
            return;
        let _instance = this;
        component_x.showMessage("");
        this.sdk.stopAcquisition().then(function () {
            _instance.acquisitionStarted = false;
            //Disabling stop once stopped
            disableEnableStartStop();
        }, function (error) {
            component_x.showMessage(error.message);
        });
    };

    FingerprintSdkTest.prototype.getInfo = function () {
        let _instance = this;
        return this.sdk.enumerateDevices();
    };

    FingerprintSdkTest.prototype.getDeviceInfoWithID = function (uid) {
        let _instance = this;
        return  this.sdk.getDeviceInfo(uid);
    };
  
  return FingerprintSdkTest;
})();


class Reader{
  constructor(){
      this.reader = new FingerprintSdkTest();
      /**
        * @type {Hand}
        */
      this.currentHand = null;
  }

  displayReader(){
      let readers = this.reader.getInfo();  // grab available readers here
      readers.then(function(availableReaders){  // when promise is fulfilled
          if(availableReaders.length > 0){
                for(let reader of availableReaders){
                  component_x.FingerprintReaderOptions.push(reader)
                }
          }
          else{
            component_x.showMessage("Please Connect the Fingerprint Reader");
          }
      })
  }
}

class Hand{
    constructor(){
        this.id = 0;
        this.index_finger = [];
        this.middle_finger = [];
    }
    generateFullHand(){
        let id = this.id;
        let index_finger = this.index_finger;
        let middle_finger = this.middle_finger;
        return JSON.stringify({id, index_finger,middle_finger});
    }
}

let myReader = new Reader();
export default {
  computed: {
    ...mapState(['loggedIn', 'endPoint', 'userEmail']),
  },
  created: async function () {
    secureStorage.setItem("default_logo", this.default_logo);
    navigate = this.$router;
    component_x = this;
    secureStorage.setItem("developerMode", false);
    if (window.requestIdleCallback) {
      await requestIdleCallback(function () {
        Fingerprint2.get(options, async function (components) {
          var values = components.map(function (component) { return component.value })
          var murmur = Fingerprint2.x64hash128(values.join(''), 31)
          browserId = murmur
        })
      })
    }
  },
  mounted: async function() {
    component_x = this;
    if (secureStorage.getItem("loggedIn") == true && secureStorage.getItem("autoLogin") == true) {
      if (component_x.accountName != "ripple") {
        let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
        if (logoSettings.length > 0 && logoSettings[0]["value"] != null && logoSettings[0]["value"] != '') {
          secureStorage.setItem("account_logo", logoSettings[0]["value"]);
        } else {
          secureStorage.setItem("account_logo", this.default_logo);
        }
        navigate.push('/landing_page');
      } else {
        secureStorage.setItem("account_logo", this.default_logo);
      }
    }
    this.timeKeepAccountDetails = secureStorage.getItem("timeKeepAccountDetails") || {};
    if (this.timeKeepAccountDetails.account_name !=undefined){
      this.validAccount = true
      this.accountName = this.timeKeepAccountDetails.account_name
      await this.getEntryTypes()
      await this.getSites()
      await this.checkIfValidAccount(false)
      if(this.timeKeepAccountDetails.time_entry_log_via == 'TES'){
        await this.toggleCamera()
      }else if (this.timeKeepAccountDetails.time_entry_log_via == 'TEB'){
        await this.beginIdentification()
      }
    }
    this.siteId = secureStorage.getItem("SelectedSiteId") || null;
  },
  data: function () {
    return {
      default_logo: "https://bxi-primer-bucket/primer-files/accounts/bxi/1703740988182_122823012307-1-BXI_default_report_logo.png",
      accountName:'',
      validAccount:false,
      loading:false,
      siteId:'',
      entryTypeId:null,
      errorMessage:null,
      successMessage:null,
      timeKeepAccountDetails:{},
      siteOptions:[],
      timeEntryOptions:[],
      email:null,
      password:null,
      loadingTimeEntry:false,
      errors:[],
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      previewImage:null,
      previewVisible:false,
      selectedFingerprintReader:"",
      FingerprintReaderOptions:[],
      startedCapture:false,
      beginIdentificationStatus:false,
      verifyFingerPrint:[],
    }
  },
  watch:{
    selectedFingerprintReader: function() {
      if(this.selectedFingerprintReader!=="" && !this.startedCapture){
        this.beginCapture()
      }
    }
  },
  methods: {
    ...mapActions(['updateLoggedInStatus', 'updateUserEmail', 'updateDefaultSite']),
    Login() {
      if(this.timeKeepAccountDetails.time_entry_log_via == 'TES' && this.isCameraOpen){
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      }
      this.$router.push("login")
    },
    signUp() {
      if(this.timeKeepAccountDetails.time_entry_log_via == 'TES' && this.isCameraOpen){
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      }
      this.$router.push("signup_now")
    },
    async checkIfValidAccount(stat) {
      this.errors = []
      this.successMessage = null
      this.loading = true
      var check_account = await HTTPRequest.postRequest(this.endPoint + "/time_entries/validate_account_name", null, { account_name: this.accountName})
      if (check_account["error"] == undefined) {
        if(check_account.is_enabled_time_keep_in_rms){
          this.validAccount = true
          secureStorage.setItem("timeKeepAccountDetails", check_account)
          this.timeKeepAccountDetails = check_account
          if(stat){
            await this.getEntryTypes()
            await this.getSites()
            if (this.timeKeepAccountDetails.time_entry_log_via == 'TES'){
              this.toggleCamera()
            }
          }
        }else {
          this.errors = ["Account is not permitted to access Time Keep Module. please contact support"]
          this.changeAccount(stat)
        }
      } else {
        this.errors = [check_account["error"] || "Account is not permitted to access Time Keep Module. please contact support"]
        this.changeAccount(stat)
      }
      this.loading = false
    },
    changeAccount(status){
      this.validAccount = false;
      if(status){
        this.accountName = null;
        this.siteId = null;
        if(this.timeKeepAccountDetails.time_entry_log_via == 'TES' && this.isCameraOpen){
          this.isCameraOpen = false;
          this.isPhotoTaken = false;
          this.isShotPhoto = false;
          this.stopCameraStream();
        }
        secureStorage.setItem("SelectedSiteId", null)
        secureStorage.setItem("timeKeepAccountDetails", {})
      }
      this.email = null;
      this.password = null;
      this.entryTypeId = null;
    },
    async getEntryTypes(){
      var time_entry_types = await HTTPRequest.getRequest(this.endPoint + '/time_entries/get_valid_time_entry_types?account_id='+this.timeKeepAccountDetails.id, null, null)
      this.timeEntryOptions = time_entry_types
    },
    async getSites(){
      var sites = await HTTPRequest.getRequest(this.endPoint + '/time_entries/valid_sites?account_id='+this.timeKeepAccountDetails.id, null, null)
      this.siteOptions = sites
    },
    addTimeEntryViaSignIn: async function () {
      this.errors = []
      this.successMessage = null
      this.loadingTimeEntry = true
      if (!this.validationTimeENtryViaSignIn()) {
        var passwordResetPayload = { email: this.email, account_name: this.accountName }
        var validateUser = await HTTPRequest.postRequest(this.endPoint + 'users/validate', null, passwordResetPayload)
        if (validateUser["error"] != undefined) {
          this.errors = ["Invalid login credentials. Please check your username or password."]
        } else {
          var bodyFormData = new FormData();
          bodyFormData.set('email', this.email);
          bodyFormData.append('password', this.password);
          bodyFormData.append('account_name', this.accountName);
          bodyFormData.append('grant_type', 'password');
          var check_password = await HTTPRequest.postRequest(this.endPoint + "time_entries/validate_password", null, {is_login_time_entry:true, account_name: this.accountName, email: this.email, password: this.password })
          if (check_password["error"] == undefined) {
            let ip_params = ""
            await axios({
              method: 'get',
              url: '//jsonip.com',
            })
              .then(function (response) {
                if (response.data != null) {
                  ip_params = response.data.ip
                }
              })
              .catch(function () {
                component_x.errors = ["Network Error on jsonip"];
              });
            await this.checkIfValidAccount(false)
            secureStorage.setItem("SelectedSiteId", this.siteId)
            if (component_x.errors.length == 0){
              var payload = {
                time_entry:{
                  site_id:this.siteId,
                  user_id: validateUser["success"][0]["id"],
                  business_date:moment().format("YYYY-MM-DD"),
                  time_entry_type_id:this.entryTypeId,
                  date_time_entry:moment(),
                  entry_origin:"browser",
                  ip_address:ip_params
                }
              }
              var createTimeEntry = await HTTPRequest.postRequest(component_x.endPoint + '/time_entries/create_time_entry?account_id='+this.timeKeepAccountDetails.id, null, payload)
              if (createTimeEntry["error"] == undefined) {
                if(this.isCameraOpen && !this.isLoading){
                  var image_url = await this.takePhoto()
                  if(image_url!=null){
                    var modulePayload = {time_entry: {image: image_url} }
                    await HTTPRequest.putRequest(component_x.endPoint + 'time_entries/'+ createTimeEntry.id, null, modulePayload)
                  }
                }
                this.successMessage = createTimeEntry["success_message"]
                this.email = null;
                this.password = null;
                this.entryTypeId = null;
              } else {
                this.errors = [createTimeEntry["error"]]
              }
            }
          } else {
            this.errors = [check_password["error"]]
          }
        
        }
      }
      this.loadingTimeEntry = false
    },
    validationTimeENtryViaSignIn(){
      this.errors.push(ValidateField.required('Site', this.siteId));
      this.errors.push(ValidateField.required('Entry Type', this.entryTypeId));
      this.errors.push(ValidateField.required('Email', this.email));
      this.errors.push(ValidateField.required('Password', this.password));
      this.errors = this._.compact(this.errors);
      return this.errors.length;
    },
    toggleCamera() {
      if(!this.isCameraOpen) {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.isLoading = true;
      
      const constraints = (window.constraints = {
        audio: false,
        video: true
      });
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error)
          alert("May the browser didn't support or there is some errors.");
        });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    async takePhoto() {
      if(!this.isPhotoTaken) {
          this.isShotPhoto = true;
          this.isPhotoTaken = true;

          const FLASH_TIMEOUT = 2500;

          setTimeout(() => {
            this.isShotPhoto = false;
            this.isPhotoTaken = false;
          }, FLASH_TIMEOUT);
        }
      const context = this.$refs.canvas.getContext('2d');
      context.canvas.width = this.$refs.camera.clientWidth
      context.canvas.height = this.$refs.camera.clientHeight
      context.drawImage(this.$refs.camera, 0, 0, this.$refs.camera.clientWidth, this.$refs.camera.clientHeight);
      const dataUrl = this.$refs.canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
      this.previewImage = dataUrl;
      let uniquePictureName = this.generateCapturePhotoName();
      let capturedPhotoFile = this.dataURLtoFile(dataUrl, uniquePictureName+'.jpg')
      const fileResponse = await uploadToS3(capturedPhotoFile, 'time_keep');
      if (fileResponse.path) {
        return fileResponse.path
      } else {
        return null
      }
    },
    handleCancel () {
      this.previewVisible = false
    },
    generateCapturePhotoName(){
      return  Math.random().toString(36).substring(2, 15)
    },
    dataURLtoFile(dataURL, filename) {
      let arr = dataURL.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    async beginIdentification(){
      if(!this.beginIdentificationStatus){
          await myReader.displayReader();
          // await this.beginCapture()
          this.beginIdentificationStatus = true;
      }
    },
    showMessage(message, message_type="error"){
      if (message_type=="error" && message!=null && message!=undefined && message!=""){
        this.errors = message.split(",")
      }else{
        this.errors = []
      }
    },
    beginCapture(){
      if(!this.readyForIdentify()){
        return;
      }
      myReader.currentHand = new Hand();
      myReader.reader.startCapture();
      this.startedCapture = true
    },
    readyForIdentify(){
      return (this.selectedFingerprintReader !== "");
    },
    clearCapture(){
      this.clearHand();
      this.startedCapture = false
      this.verifyFingerPrint = []
    },
    clearHand(){
      myReader.currentHand = null;
    },
    stopCapture(){
      myReader.reader.stopCapture();
    },
    showSampleCaptured(s){
      if (this.verifyFingerPrint.length < 1){
        this.verifyFingerPrint.push(s[0].Data)
      }
    },
    storeSample(sample){
      let samples = JSON.parse(sample.samples);
      this.showSampleCaptured(samples);
      return;
    },
    validationTimeEntryViaBiometric(){
      this.errors.push(ValidateField.required('Site', this.siteId));
      this.errors.push(ValidateField.required('Entry Type', this.entryTypeId));
      this.errors.push(ValidateField.required('Fingerprint Reader',this.selectedFingerprintReader))
      this.errors.push(ValidateField.requiredOne('Scanned Finger',this.verifyFingerPrint))
      this.errors = this._.compact(this.errors);
      return this.errors.length;
    },
    async addTimeEntryViaBiometric(){
      this.errors = []
      if (!this.validationTimeEntryViaBiometric()){
        var finger = this.verifyFingerPrint[0]
        var response =  await HTTPRequest.postRequest(this.endPoint + 'users/account_verify_users_finger', null,{finger:finger,account_id:this.timeKeepAccountDetails.id})
        if (response["error"] == undefined){
          let ip_params = ""
          await axios({
            method: 'get',
            url: '//jsonip.com',
          }).then(function (response) {
              if (response.data != null) {
                // console.log(response.data.ip)
                ip_params = response.data.ip
              }
          })
          .catch(function () {
            component_x.errors = ["Network Error on jsonip"];
          });
          secureStorage.setItem("SelectedSiteId", this.siteId)
          if (component_x.errors.length==0){
            var payload = {
              time_entry:{
                site_id:this.siteId,
                user_id: secureStorage.getItem("userId"),
                business_date:moment().format("YYYY-MM-DD"),
                time_entry_type_id:this.entryTypeId,
                date_time_entry:moment(),
                entry_origin:"browser",
                ip_address:ip_params
              }
            }
            var createTimeEntry = await HTTPRequest.postRequest(component_x.endPoint + '/time_entries/create_time_entry?account_id='+this.timeKeepAccountDetails.id, null, payload)
            if (createTimeEntry["error"] == undefined) {
              this.successMessage = createTimeEntry["success_message"]
              this.email = null;
              this.password = null;
              this.entryTypeId = null;
              this.clearCapture()
            } else {
              this.errors = [createTimeEntry["error"]]
              this.clearCapture()
            }
          }
        }else{
          this.clearCapture()
          this.errors = ["Fingerprint is not match. please rescan finger"]
        }
      }
    }
  }
}
</script>

<style scoped>
/* .consolidatedErrors_modal{
  height: 100vh !important;
} */
.ant-select-selection{
  height: 100% !important;
  border: none !important;
}
.ant-select-open{
  border: none !important;
  border-color: transparent!important;
  box-shadow: none!important;
}
.ant-select-selection__rendered{
  margin-left: 0px!important;
}
.signUpText{
 color: #2dce89;
}

</style>